<template>
    <div class="content">
        <!-- 面包屑导航 -->
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> {{$t("title.appManage") }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $t("title.appList") }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <el-card>
            <el-form
                class="form_pad"
                ref="formPad"
                :inline="true"
                :model="listQuery"
                >
                <el-row class="clear_fix">
                    <el-form-item :label="$t('common.APPplatform')">
                        <el-select
                            v-model="listQuery.os"
                            clearable
                            style="width: 150px"
                            :placeholder="$t('common.selectAppPlat')"
                            >
                            <el-option
                                v-for="item in osList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('common.searchContent')">
                        <el-input :placeholder="$t('common.enterContent')" style="width: 150px" v-model="listQuery.name"  class="input-with-select"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.searchID')">
                        <el-input :placeholder="$t('common.searchID')"  v-model.number="listQuery.id" style="width: 150px;" class="input-with-select"></el-input>
                    </el-form-item>
                </el-row>
                <el-row class="search-btns">
                    <el-button type="primary" icon="el-icon-search" @click="querySearch()">{{$t('common.search')}}</el-button>
                </el-row>
            </el-form>
        </el-card>
        <div class="mb10">
            <el-button type="primary" class="handle-del mr10" @click="handleAdd">{{$t("common.addApp")}}</el-button>
        </div>
        <el-card>
            <div class="table-container">
                <div>
                    <el-table v-if="tableData && tableData.length > 0" :data="tableData" class="table" v-loading="listLoading">
                        <el-table-column prop="id" :label="$t('table.appId')" align="left"></el-table-column>
                        <el-table-column prop="name" :label="$t('table.appName')" align="left">
                          <template slot-scope="scope">
                            {{ scope.row.name }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="package_name" :label="$t('table.appPackageName')" width="150px" align="left"></el-table-column>
                        <el-table-column prop="os" :label="$t('table.appPlat')"  align="left">
                             <template slot-scope="scope">
                                {{scope.row.os == 1? 'Andriod' : 'ios'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="docking_type" :label="$t('table.accessMode')"  align="left">
                            <template slot-scope="scope">
                                {{scope.row.docking_type == '1'? 'sdk' : 'api'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="dau" :label="$t('table.appDaily')" align="left"></el-table-column>
                        <el-table-column :label="$t('table.status')"   width="160"  align="left">
                            <template slot-scope="scope">
                                <div style="position: relative;">
                                    <el-tag :type="statusBtn(scope.row.status_info.status).type">
                                        {{scope.row.status_info.status | filterStatus($i18n)}}
                                    </el-tag>
                                    <el-tooltip v-if="scope.row.status_info.status == 3" class="item" effect="dark" :content="scope.row.status_info.msg" placement="top">
                                        <Icon v-if="scope.row.status_info.status == 3" name="info" class="svg-icon info-icon"/>
                                    </el-tooltip>
                                </div>
                                <!-- <el-tooltip v-if="scope.row.status_info.status == 3" class="item" effect="dark" :content="scope.row.status_info.msg" placement="top">
                                    <i class="el-icon-warning-outline" :style="statusBtn(scope.row.status_info.status).color"></i>
                                </el-tooltip> -->
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('table.operation')" align="left" width="190">
                            <template slot-scope="scope">
                                <!-- 审核驳回之后不能编辑 -->
                                <!-- <el-button type="text" :disabled="scope.row.status_info.status == 3 || scope.row.status_info.status == 2" @click="handleEdit(scope.$index, scope.row)">{{$t('operation.edit')}}</el-button> -->
                                <!-- 审核通过或审核驳回的应用可以再次编辑，提交后重新走审核流程 -->
                                <el-button type="text" size="large" @click="handleEdit(scope.$index, scope.row)">{{$t('operation.edit')}}</el-button>
                                <el-button type="text" size="large" @click="handleView(scope.$index, scope.row)">{{$t('operation.detail')}}</el-button>
                                <el-button type="text" size="large" :disabled="scope.row.status_info.status == 3" @click="handleAdPosition(scope.$index, scope.row)">{{$t('operation.adsense')}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div v-else class="nodata">
                        <img src="../../../assets/img/nodata.png" class="nodata_img">
                        <p class="nodata_text">暂无数据</p>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next"
                    :total="itemCount"
                    >
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <update
            v-if="dialogVisible"
            :title="title"
            :visible="dialogVisible"
            :rowData="rowData"
        >
        </update>
    </div>
</template>

<script>
import update from './update'
import util from '@/utils/util'
    export default {
        components: { update },
        data() {
            return {
                dialogVisible: false,
                listLoading: false,
                title: "",
                cur_page: 1,
                select_word: '',
                itemCount: 0,
                openPushText: '',
                tableData: [],
                rowData:{},
                listQuery: {
                    os: null,
                    name: "",
                    id: null,
                    page: 1,
                    page_size: 20,
                },
                osList: [
                    {
                        id: 1,
                        label: 'Andriod'
                    },
                    {
                        id: 2,
                        label: 'ios'
                    },
                ],
            }
        },
        created() {
            this.getData();
        },
        filters:{
            filterStatus(status, type) {
            let str = ""
            switch(status) {
                case 1 : //待审核
                str = type.t('status.checkPending');
                break;
                case 2 : //审核通过
                str = type.t('status.approved');
                break;
                case 3 : //审核驳回
                str = type.t('status.rejected');
                break;
            }
            return str;
            },
        },
        computed: {
            statusBtn() {
                return function(status) {
                    let obj = {
                        type: "",
                        color: ""
                    }
                    switch(status) {
                        case 1 :
                            obj.type = "warning"
                            obj.color = "color:#FF8900"
                        break;
                        case 2 :
                            obj.type = "success"
                            obj.color = "color:#0EAC01"
                        break;
                        case 3 :
                            obj.type = "danger"
                            obj.color = "color:#DD2A4D"
                        break;
                    }
                    return obj;
                }
            }
        },
        methods: {
            // 分页导航
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getData();
            },
            handleSizeChange(val) {
                this.listQuery.page = 1
                this.listQuery.page_size = val
                this.getData()
            },
            querySearch() {
                this.listQuery.page = 1
                this.getData();
            },
            // 获取应用
            getData() {
                this.listLoading = true
                let params = util.filterParams(this.listQuery)
                this.__postData('sspAppList', params, (res) => {
                    // if(!res.length){ return }
                    if(res.list !== null){
                        this.tableData = res.list;
                    }else{
                        this.tableData = [];
                    }
                    if(res.code == 1) {
                        this.$message.error(res.msg);
                    }
                    this.itemCount = res.total;
                    this.listLoading = false
                })
            },
            search() {
                this.getData();
            },
            handleView(index, row) {
                // let path = '/ssp/app/view?id='+ row.id
                // this.$router.push(path)
                this.title = this.$t('common.lookApp')
                this.dialogVisible = true
                this.rowData = JSON.parse(JSON.stringify(row))
            },
            handleEdit(index, row) {
                // let path = '/ssp/app/edit?id='+ row.id
                // this.$router.push(path)
                this.title = this.$t('common.editApp')
                this.dialogVisible = true
                this.rowData = JSON.parse(JSON.stringify(row))
            },
            handleAdPosition(index, row){
                let path = '/ad/list?id='+ row.id
                this.$router.push(path)
            },
            handleAdd() {
                // this.$router.push('/ssp/app/add')
                this.title = this.$t('common.addApp')
                this.dialogVisible = true
            },
        }
    }

</script>

<style scoped>
    .table-title {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center
    }
    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .btn-status-style {
        padding: 2px;
        vertical-align:middle;
    }
    .status-text {
        display: inline;
        vertical-align:middle;
    }
    .info-icon {
        position: absolute;
        top: 8px;
        width: 14px;
        height: 14px;
        vertical-align: baseline;
        margin-left: 10px;
    }
</style>
